import { render, staticRenderFns } from "./referee-login.vue?vue&type=template&id=85a492ee&scoped=true"
import script from "./referee-login.vue?vue&type=script&lang=js"
export * from "./referee-login.vue?vue&type=script&lang=js"
import style0 from "./referee-login.vue?vue&type=style&index=0&id=85a492ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a492ee",
  null
  
)

export default component.exports